<!-- extra div required for automatic canvas resizing to work  -->
<div style="position: relative; height: 100%; width: 100%">
  <canvas #canvas></canvas>
</div>
